module.exports = __webpack_public_path__ + "img/index-3.090b8423.png";